import { IPlaceholdersConfig } from "../../IPlaceholdersConfig";

export const DefaultPlaceholders: IPlaceholdersConfig = {
  pan: "**** **** **** ****",
  expirydate: "MM/YY",
  securitycode: "***",
};
